"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _ObjectForm = _interopRequireDefault(require("@/components/ObjectForm"));
var _validate = require("@/libs/validate1");
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    formIcon: _ObjectForm.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          schoolName: [{
            required: true,
            message: "请选择所属学校",
            trigger: "blur"
          }],
          userName: [{
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }, {
            min: 2,
            max: 4,
            message: "姓名长度在2到4个字符",
            trigger: "blur"
          }],
          password: [{
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }, {
            validator: _validate.PSWRULE,
            trigger: "blur"
          }],
          ICCode: [
          // { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            validator: _validate.validateIdNo,
            trigger: "blur"
          }],
          email: [{
            required: true,
            message: "请输入邮箱",
            trigger: "blur"
          }, {
            validator: _validate.validateEMail,
            trigger: "blur"
          }],
          telNumber: [{
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          }, {
            validator: _validate.validatePhoneTwo,
            trigger: "blur"
          }]
        },
        labelWidth: "120px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [{
          type: "input",
          label: "登录账号",
          isDisabled: false,
          placeholder: "登录账号",
          prop: "loginName",
          value: "",
          required: true,
          span: 12
        }, {
          type: "input",
          label: "姓名",
          isDisabled: false,
          placeholder: "请输入姓名",
          prop: "userName",
          value: "",
          required: true,
          span: 12
        }, {
          type: "input",
          label: "身份证号",
          isDisabled: false,
          placeholder: "请输入身份证号",
          prop: "ICCode",
          value: "",
          required: true,
          span: 12
        }, {
          type: "input",
          label: "手机号",
          isDisabled: false,
          placeholder: "请输入手机号",
          prop: "telNumber",
          value: "",
          required: true,
          span: 12
        }, {
          type: "input",
          label: "邮箱",
          isDisabled: false,
          placeholder: "请输入邮箱",
          prop: "email",
          value: "",
          span: 12
        }]
      },
      info: {}
    };
  },
  methods: {
    submit: function submit(e) {}
  },
  created: function created() {
    this.formData.formItem[0].value = this.$route.query.loginName;
    this.formData.formItem[1].value = this.$route.query.name;
    this.formData.formItem[2].value = this.$route.query.idCard;
    this.formData.formItem[3].value = this.$route.query.phoneNumber;
    this.formData.formItem[4].value = this.$route.query.mail;
  }
};